export function calculateDiscountPercentage(mrp, salesPrice) {
    if (mrp <= 0 || salesPrice <= 0) {
        return 0;
    }

    const discount = mrp - salesPrice;
    const percentage = (discount / mrp) * 100;

    return Math.floor(percentage.toFixed(2));
}

export const formatSlug = (str) => {
    if (str) {
        return str.trim().replace(/\s+/g, '-');
        
    } else {
        return '';
        
    }
};